const jaundice=[
    {
    label:"Pain:",
    controlType:"radio button",
    options:["Painful", "Painless"]
    },

    {
    label:"Urine:",
    controlType:"radio button",
    options:["Normal coloured","Dark"]
    },

    {
    label:"Stools:",
    controlType:"radio button",
    options:["Normal coloured", "Pale"]
    },

    {
    label:"Alcohol Excess:",
    controlType:"radio button",
    options:["Yes", "No"]
    },
    {
    label:"IV drug abuse:",
    controlType:"radio button",
    options:["Yes", "No"]
    },
    {
    label:"Foreign Travel:",
    controlType:"radio button",
    options:["Yes", "No"]
    },
    {
    label:"Duration:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }

]

export default jaundice